import { TEntity, TLanguage } from 'contexts/app-context/types'

import { useQuery } from '@tanstack/react-query'

import { getFaqsQueryOptions } from './queries/getFaqsQueryOptions'

type UseGetFAQsProps = {
  queryText: string
  language: TLanguage
  userSelectedEntity: TEntity
  fetchAutomatically?: boolean
}

export const useGetFAQs = ({
  queryText,
  language,
  userSelectedEntity,
  fetchAutomatically,
}: UseGetFAQsProps) => {
  const {
    data: faqs,
    isLoading: isFaqsLoading,
    isError: isFaqsError,
    refetch: fetchFaqs,
  } = useQuery({
    ...getFaqsQueryOptions({ queryText, language, userSelectedEntity }),
    enabled: fetchAutomatically ?? false,
  })

  return {
    faqs,
    isFaqsLoading,
    isFaqsError,
    fetchFaqs,
  }
}
